import { FC } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import XModal from "../modal/XModal";
import { copyToClipboard } from "../../utils/helper";
import { COLORS } from "../../constants/colors";

const SUPPORT_EMAIL = "help@patientcampaign.com";

interface HelpModalProps {
  show: boolean;
  handleClose: () => void;
}

const HelpModal: FC<HelpModalProps> = ({ show, handleClose }) => {
  return (
    <XModal
      show={show}
      handleClose={handleClose}
      title={
        <span className="d-flex align-items-center justify-content-center">
          <span
            className="d-flex align-items-center justify-content-center me-2"
            style={{
              width: 32,
              height: 32,
              borderRadius: "50%",
              backgroundColor: "#EEF1F6",
            }}
          >
            <FontAwesomeIcon icon={faEnvelope} style={{ color: COLORS.primary, fontSize: 14 }} />
          </span>
          Contact Support
        </span>
      }
      className="help-modal"
      body={
        <div className="text-center">
          <p className="mb-2">
            Need help? Reach out to our support team and we'll get back to you shortly.
          </p>
          <div
            className="d-flex align-items-center justify-content-between mx-auto px-3 py-2"
            style={{
              maxWidth: 300,
              borderRadius: 8,
              border: "1px solid #E2E6ED",
              backgroundColor: "#F8F9FB",
            }}
          >
            <span style={{ color: COLORS.primary }} className="fw-semibold">
              {SUPPORT_EMAIL}
            </span>
            <FontAwesomeIcon
              icon={faCopy}
              onClick={() => copyToClipboard(SUPPORT_EMAIL)}
              className="ms-3 cursor-pointer"
              style={{ color: COLORS.primary }}
            />
          </div>
        </div>
      }
    />
  );
};

export default HelpModal;
